// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".default-message[data-v-11cbde00] {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
